import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { siteContent, images } from "../../data/content";

export const Footer = () => {
  return (
    <footer className="bg-charcoal-paper border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img 
                src={images.logo} 
                alt="Samudra Charcoal Logo" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-zinc-400 text-sm leading-relaxed mb-4">
              Premium coconut shell charcoal briquettes manufacturer since 2016. Export-ready with private label services.
            </p>
            <p className="text-zinc-500 text-xs font-mono">
              {siteContent.company.legalName}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-white uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-zinc-400 hover:text-coconut text-sm transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/packaging" className="text-zinc-400 hover:text-coconut text-sm transition-colors">
                  Packaging & Private Label
                </Link>
              </li>
              <li>
                <Link to="/quality" className="text-zinc-400 hover:text-coconut text-sm transition-colors">
                  Quality & Factory
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-zinc-400 hover:text-coconut text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-400 hover:text-coconut text-sm transition-colors">
                  Contact / Request Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-heading text-white uppercase tracking-wider mb-4">Our Product</h4>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>Charcoal Briquette</li>
              <li>100% Coconut Shell</li>
              <li>Max 2.5% Ash Content</li>
              <li>Private Label Available</li>
              <li>Custom Packaging</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-white uppercase tracking-wider mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${siteContent.contact.email}`}
                  className="flex items-center gap-3 text-zinc-400 hover:text-coconut text-sm transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4 flex-shrink-0" />
                  {siteContent.contact.email}
                </a>
              </li>
              <li>
                <a
                  href={siteContent.contact.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-zinc-400 hover:text-[#25D366] text-sm transition-colors"
                  data-testid="footer-whatsapp"
                >
                  <Phone className="w-4 h-4 flex-shrink-0" />
                  {siteContent.contact.whatsapp}
                </a>
              </li>
              <li
                className="flex items-start gap-3 text-zinc-400 text-sm"
                data-testid="footer-location"
              >
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                {siteContent.contact.location}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm">
            © {new Date().getFullYear()} {siteContent.company.brandName}. All rights reserved.
          </p>
          <p className="text-zinc-600 text-xs">
            Established 2016
          </p>
        </div>
      </div>
    </footer>
  );
};
